import { getCustomerId, getLoId } from 'Common';
import {
    DocPromptExamples,
    FHADocPromptExamples,
    VADocPromptExamples,
    FreddieDocPromptExamples,
    UsdaDocPromptExamples,
    NewWaveLendingDIPrimeDocPromptExamples,
    NewWaveLendingDIDocPromptExamples,
    NewWaveLendingPLDocPromptExamples,
    NewWaveLendingVOEDocPromptExamples,
    NewWaveLendingEPDocPromptExamples,
    NewFiNQMEPDocPromptExamples,
    NewFiNQMIEPDocPromptExamples,
    NewFiDSCRDocPromptExamples,
    NewFiFNDSCRDocPromptExamples,
    NewFiNQMPDocPromptExamples,
    NewFiNQMIPDocPromptExamples,
    NewFiPINNDocPromptExamples,
    NewFiRAINERDocPromptExamples,
} from './utils'

// 这里的配置可能会存在问题，因为在页面初始化的时候只会运行一次，如果后续路径发生变化，这里的值不会更新，需要注意
export const IS_IFRAMES = window.location.pathname.includes('/workflow');
export const IS_GUIDELINE_GPT = window.location.pathname.includes('/guidelinegpt') && !IS_IFRAMES;
export const IS_MORTGAGE_GPT = ()=> window.location.pathname.includes('/app/mortgagegpt');

export const PATH_CUSTOMER_ID = window.location.pathname.split('/')[3];
export const WHITE_LIST = ["37916cb4-eccf-412a-95f0-9a498c442903", "796d49e3-8a98-4967-8bd6-a8dfbe65261b", "0cd9b65a-df0c-4479-82a8-dcb7a6b021f6", "66e792ff-0810-474b-a6ff-425bdd5cd4a4", "3e906cfb-4dba-4809-a14f-ab4fc6abcb75", "90e1549b-b7b4-4530-a11b-1ad01888c29b", "975cf645-5165-481a-b8a7-4e8f6f488a9f", "c8fae884-d0d1-469a-aa9e-da51f6601f6f"];
export const IS_ZEITRO = getCustomerId() === 'zeitro' || WHITE_LIST.includes(getLoId());
export const IS_NATIONDIRECT = getCustomerId() === 'nationdirect';
export const IS_GREENBOX = getCustomerId() === 'greenbox';
export const IS_NEW_WAVE = getCustomerId() === ('newwave');
export const IS_CALHFA = getCustomerId() === 'calhfa';

const LENDER_CONFIGS = ['zeitro', 'greenbox', 'calhfa'];

 // 这里走模糊匹配策略，适配比如  newwave1、newwave2 这种情况
const LENDER_FUZZY_MATCHING_CONFIGS = ['newwave', 'nationdirect', 'newfi', "nationsdirect", "unitedmortgage","googain", "megacapital", "nationwide", "gomortgage"];

 // 这些 “CUSTOMER” 隐藏 “Contact” 相关功能（模糊匹配）
const HIDE_CONTACT_CUSTOMER_IDS = ["greenbox", "nationsdirect", "calhfa", "successlending", "megacapital", "googain", "gomortgage"];

/**
 * @name fuzzyMatching 模糊匹配方法 
 * @param ids 需要匹配的 “CUSTOMER_ID”
 */
export function fuzzyMatching(ids){
    const CUSTOMER_ID = IS_IFRAMES ? PATH_CUSTOMER_ID : getCustomerId();
    if(!CUSTOMER_ID) return false;
    return Boolean(ids.find(id => CUSTOMER_ID.includes(id)));
}

// 获取所有白名单用户ID
export const IS_WHITE_LIST = LENDER_CONFIGS.includes(getCustomerId()) || WHITE_LIST.includes(getLoId()) || LENDER_CONFIGS.includes(PATH_CUSTOMER_ID) || fuzzyMatching(LENDER_FUZZY_MATCHING_CONFIGS)

// 显示 "Contact" 功能 (IFRAMES模式、和被模糊匹配的上的 CUSTOMER_ID 都不显示 Contact)
export const SHOW_CONTACT = !IS_IFRAMES && !fuzzyMatching(HIDE_CONTACT_CUSTOMER_IDS);

// 限制、新增、编辑 "Contact" 功能的 CUSTOMER_ID
export const HIDE_CONTACT_ADD_EDIT = ['nationwide'];

export const PDF_GUIDELINES = {
    FANNIE_MAE: '/fannie_mae_guideline.pdf',
    VA: '/VA_guideline.pdf',
    FHA: '/FHA.pdf',
    FREDDIE: '/freddie.pdf',
    USDA: '/USDA.pdf',
    NEWFI_JUMBO: '/newfi_jumbo_guideline.pdf',
    NEW_WAVE_LENDING_DI_PRIME: '/nonqm/new_wave_lending/DI_PRIME.pdf',
    NEW_WAVE_LENDING_DI: '/nonqm/new_wave_lending/DI.pdf',
    NEW_WAVE_LENDING_PL: '/nonqm/new_wave_lending/PL.pdf',
    NEW_WAVE_LENDING_VOE: '/nonqm/new_wave_lending/VOE.pdf',
    NEW_WAVE_LENDING_EP: '/nonqm/new_wave_lending/EP.pdf',
    NEWFI_NQMEP: '/nonqm/newfi/NQMEP.pdf',
    NEWFI_NQMIEP: '/nonqm/newfi/NQMIEP.pdf',
    NEWFI_DSCR: '/nonqm/newfi/DSCR.pdf',
    NEWFI_FNDSCR: '/nonqm/newfi/FNDSCR.pdf',
    NEWFI_NQMP: '/nonqm/newfi/NQMP.pdf',
    NEWFI_NQMIP:'/nonqm/newfi/NQMIP.pdf',
    NEWFI_PINN: '/nonqm/newfi/PINN.pdf',
    NEWFI_RAINER: '/nonqm/newfi/RAINER.pdf',
    AMWEST_ASSETQ: '/nonqm/amwest/ASSETQ.pdf',
    AMWEST_AITIN: '/nonqm/amwest/AITIN.pdf',
    AMWEST_AONE: '/nonqm/amwest/AONE.pdf',
    AMWEST_ADVANTAGE: '/nonqm/amwest/ADVANTAGE.pdf',
    AMWEST_INVESTOR: '/nonqm/amwest/INVESTOR.pdf',
    AMWEST_INVESTOR_PLUS: '/nonqm/amwest/INVESTOR_PLUS.pdf',
    AMWEST_BK: '/nonqm/amwest/BK.pdf',
    CONSTRUCTIVE_CAPITAL_STANDARD_DSCR: '/nonqm/constructive_capital/standardDSCR.pdf',
    CONSTRUCTIVE_CAPITAL_EXPANDED_DSCR: '/nonqm/constructive_capital/expandedDSCR.pdf',
    AAA_PRIME_NO_DOC: '/nonqm/aaa/Prime_No_Doc.pdf',
    AAA_NO_JOB_NO_INCOME: '/nonqm/aaa/No_Job_No_Income.pdf',
    AAA_SELF_PREPARED_PL: '/nonqm/aaa/Self-Prepared_P&L_WVOE.pdf',
    AAA_CPA_PREPARED_PL: '/nonqm/aaa/CPA-Prepared_P&L_WVOE.pdf',
    AAA_DSCR_PRIME: '/nonqm/aaa/DSCR_Prime.pdf',
    AAA_DSCR: '/nonqm/aaa/DSCR.pdf',
    AAA_BANK_STATEMENT: '/nonqm/aaa/Bank_Statement.pdf',
    AAA_BRIDGE_LOAN: '/nonqm/aaa/Bridge_Loan_12-month_balloon.pdf',
    AAA_FIX_FLIP: '/nonqm/aaa/Fix_&_Flip.pdf',
    AAA_PRIME_CES: '/nonqm/aaa/Prime_CES_Closed_End_Second.pdf',
    AAA_DSCR_CES: '/nonqm/aaa/DSCR_CES_Closed-End_Second.pdf',
    AAA_EXPANDED_HELOC: '/nonqm/aaa/Expanded_HELOC.pdf',
    THUNDERBIRD: '/nonqm/thunderbird/Thunderbird.pdf',
    SCENARIO_GMCC: '/GMCC_Scenario.pdf',
    'greenbox_ces_fd_bs_pl': '/scenario_pdfs/Greenbox_CES-FD-1224BS-1224-PL-Only.pdf',
    'greenbox_combo_ces_bs_fd': '/scenario_pdfs/Greenbox_Combo95-CES-24BSFD.pdf',
    'greenbox_combo_bs_fd': '/scenario_pdfs/Greenbox_Combo95-24BS-FD.pdf',
    'greenbox_dscr_5_10_units_2_8_mix_use': '/scenario_pdfs/Greenbox_DSCR-5-10-UNITS-and-2-8-MIX-USE.pdf',
    'greenbox_elite_dscr': '/scenario_pdfs/Greenbox_ELITE-DSCR.pdf',
    'greenbox_dscr_no_ratio': '/scenario_pdfs/Greenbox_DSCR-NO-RATIO.pdf',
    'greenbox_elite_plus_dscr': '/scenario_pdfs/Greenbox_Elite-Plus-DSCR.pdf',
    'greenbox_elite_plus_bs_pl_fd': '/scenario_pdfs/Greenbox_Elite-Plus-1224BS-24PL-Only-1224PL-w-3BS-FD.pdf',
    'greenbox_elite_bs_pl_fd_1099': '/scenario_pdfs/Greenbox_Elite-1224BS-PL-Only-PL-w-3BS-1224-FD-1099.pdf',
    'greenbox_elite_wvoe': '/scenario_pdfs/Greenbox_ELITE-WVOE-AU.pdf',
    'greenbox_fn_fd': '/scenario_pdfs/Greenbox_FN-Full-Doc.pdf',
    'greenbox_fn_dscr_itin': '/scenario_pdfs/Greenbox_FN-DSCR-ITIN-DSCR.pdf',
    'greenbox_itin_bs': '/scenario_pdfs/Greenbox_ITIN-12-or-24-BS.pdf',
    'greenbox_itin_fd': '/scenario_pdfs/Greenbox_ITIN-FD.pdf',
    'greenbox_np_pl_fd': '/scenario_pdfs/Greenbox_NP-1224BS-1224PL-w-3BS-and-1224-FD.pdf',
    'greenbox_rh_bs_fd': '/scenario_pdfs/Greenbox_RH-24BS-and-FD.pdf',
    'greenbox_super_jumbo': '/scenario_pdfs/Greenbox_SUPER-JUMBO-1224BS-1224FD.pdf',
    'greenbox_ces_dscr': '/scenario_pdfs/Greenbox_CES-DSCR.pdf',
    'googain-panther_panther-agency-eligible-noo-2nd-home-matrix': '/scenario_pdfs/Googain-Panther_Panther-Agency-Eligible-NOO-2nd-home-Matrix.pdf',
    'googain-panther_panther-core-credit-guidelines': '/scenario_pdfs/Googain-Panther_Panther-CORE-Credit-Guidelines.pdf',
    'googain-panther_panther-core-credit-matrix': '/scenario_pdfs/Googain-Panther_Panther-CORE-Credit-Matrix.pdf',
    // Willow
    'googain-willow_willow-cash-flow-advantage': '/scenario_pdfs/Googain-Willow_Willow-Cash-Flow-Advantage.pdf',
    'googain-willow_willow-equity-advantage': '/scenario_pdfs/Googain-Willow_Willow-Equity-Advantage.pdf',
    'googain-willow_willow-equity-advantage-ces-eligibility': '/scenario_pdfs/Googain-Willow_Willow-Equity-Advantage-CES-Eligibility.pdf',
    'googain-willow_willow-investor-advantage': '/scenario_pdfs/Googain-Willow_Willow-Investor-Advantage.pdf',
    'googain-willow_willow-investor-advantage-eligibility': '/scenario_pdfs/Googain-Willow_Willow-Investor-Advantage-Eligibility.pdf',
    'googain-willow_willow-non-agency-advantage': '/scenario_pdfs/Googain-Willow_Willow-Non-Agency-Advantage.pdf',
    'googain-willow_willow-non-agency-guidelines': '/scenario_pdfs/Googain-Willow_Willow-Non-Agency-Guidelines.pdf',
    'googain-willow_willow-professional-investor': '/scenario_pdfs/Googain-Willow_Willow-Professional-Investor.pdf',
    'googain-willow_willow-summary-program-matrix': '/scenario_pdfs/Googain-Willow_Willow-Summary-Program-Matrix.pdf',
    'googain-willow_willow-super-jumbo': '/scenario_pdfs/Googain-Willow_Willow-Super-Jumbo.pdf',
    'googain-willow_willow-titanium-advantage': '/scenario_pdfs/Googain-Willow_Willow-Titanium-Advantage.pdf',
    // Pebbles
    'googain-pebbles_pebbles-delegated-nonqm-matrix': '/scenario_pdfs/Googain-Pebbles_Pebbles-Delegated-NonQM-Matrix.pdf',
    // Bahamas
    'googain-bahamas_bahamas-loan-eligibility-guidelines': '/scenario_pdfs/Googain-Bahamas_Bahamas-Loan-Eligibility-Guidelines.pdf',
    'googain-bahamas_bahamas-loan-eligibility-guidelines-equity-solutions': '/scenario_pdfs/Googain-Bahamas_Bahamas-Loan-Eligibility-Guidelines-Equity-Solutions.pdf',
    'googain-bahamas_bahamas-matrix': '/scenario_pdfs/Googain-Bahamas_Bahamas-Matrix.pdf',
    'googain-bahamas_bahamas-matrix-equity-solutions': '/scenario_pdfs/Googain-Bahamas_Bahamas-Matrix-Equity-Solutions.pdf',
    // Glory
    'googain-glory_glory-2nd-lien-guidelines': '/scenario_pdfs/Googain-Glory_Glory-2nd-Lien-Guidelines.pdf',
    'googain-glory_glory-nqm': '/scenario_pdfs/Googain-Glory_Glory-NQM.pdf',
    'googain-glory_glory-qm-aus': '/scenario_pdfs/Googain-Glory_Glory-QM-AUS.pdf',
}

export const CONTENT_TYPES = {
    FANNIE_MAE: 'fanieMaeDocName',
    FHA: 'FHA',
    VA: 'va',
    FREDDIE: 'freddie',
    USDA: 'usda',
    NEW_WAVE_LENDING_DI_PRIME: 'newWaveLendingDIPrime',
    NEW_WAVE_LENDING_DI: 'newWaveLendingDI',
    NEW_WAVE_LENDING_PL: 'newWaveLendingPL',
    NEW_WAVE_LENDING_VOE: 'newWaveLendingVOE',
    NEW_WAVE_LENDING_EP: 'newWaveLendingEP',
    NEWFI_NQMEP: 'NewFiNQMEP',
    NEWFI_NQMIEP: 'NewFiNQMIEP',
    NEWFI_DSCR: 'NewFiDSCR',
    NEWFI_FNDSCR: 'NewFiFNDSCR',
    NEWFI_NQMP: 'NewFiNQMP',
    NEWFI_NQMIP: 'NewFiNQMIP',
    NEWFI_PINN: 'NewFiPINN',
    NEWFI_RAINER: 'NewFiRAINER',
    AMWEST_ASSETQ: 'AWAssetQ',
    AMWEST_AITIN: 'AWAITIN',
    AMWEST_AONE: 'AWAOne',
    AMWEST_ADVANTAGE: 'AWAdvantage',
    AMWEST_INVESTOR: 'AWInvestor',
    AMWEST_INVESTOR_PLUS: 'AWInvestorPlus',
    AMWEST_BK: 'AWBK',
    CONSTRUCTIVE_CAPITAL_STANDARD_DSCR: 'Constructive_Standard',
    CONSTRUCTIVE_CAPITAL_EXPANDED_DSCR: 'Constructive_Expanded',
    AAA_PRIME_NO_DOC: 'LenderAAAPrimeNoDoc',
    AAA_NO_JOB_NO_INCOME: 'LenderAAANoJobNoIncome',
    AAA_SELF_PREPARED_PL: 'LenderAAASelfPreparedPL',
    AAA_CPA_PREPARED_PL: 'LenderAAACPAPreparedPL',
    AAA_DSCR_PRIME: 'LenderAAADSCRPrime',
    AAA_DSCR: 'LenderAAADSCR',
    AAA_BANK_STATEMENT: 'LenderAAABankStatement',
    AAA_BRIDGE_LOAN: 'LenderAAABridgeLoan',
    AAA_FIX_FLIP: 'LenderAAAFixFlip',
    AAA_PRIME_CES: 'LenderAAAPrimeCES',
    AAA_DSCR_CES: 'LenderAAADSCRCES',
    AAA_EXPANDED_HELOC: 'AAAExpandedHELOC',
    THUNDERBIRD: 'Thunderbird',
    SCENARIO_GMCC: 'GMCC_guidelines_demo',
    SCENARIO_DESK: 'SCENARIO_DESK_guidelines',
    'greenbox_ces_fd_bs_pl': 'greenbox_ces_fd_bs_pl',
    'greenbox_combo_ces_bs_fd': 'greenbox_combo_ces_bs_fd',
    'greenbox_combo_bs_fd': 'greenbox_combo_bs_fd',
    'greenbox_dscr_5_10_units_2_8_mix_use': 'greenbox_dscr_5_10_units_2_8_mix_use',
    'greenbox_elite_dscr': 'greenbox_elite_dscr',
    'greenbox_dscr_no_ratio': 'greenbox_dscr_no_ratio',
    'greenbox_elite_plus_dscr': 'greenbox_elite_plus_dscr',
    'greenbox_elite_plus_bs_pl_fd': 'greenbox_elite_plus_bs_pl_fd',
    'greenbox_elite_bs_pl_fd_1099': 'greenbox_elite_bs_pl_fd_1099',
    'greenbox_elite_wvoe': 'greenbox_elite_wvoe',
    'greenbox_fn_fd': 'greenbox_fn_fd',
    'greenbox_fn_dscr_itin': 'greenbox_fn_dscr_itin',
    'greenbox_itin_bs': 'greenbox_itin_bs',
    'greenbox_itin_fd': 'greenbox_itin_fd',
    'greenbox_np_pl_fd': 'greenbox_np_pl_fd',
    'greenbox_rh_bs_fd': 'greenbox_rh_bs_fd',
    'greenbox_super_jumbo': 'greenbox_super_jumbo',
    'greenbox_ces_dscr': 'greenbox_ces_dscr',
    'googain-panther_panther-agency-eligible-noo-2nd-home-matrix': 'googain-panther_panther-agency-eligible-noo-2nd-home-matrix',
    'googain-panther_panther-core-credit-guidelines': 'googain-panther_panther-core-credit-guidelines',
    'googain-panther_panther-core-credit-matrix': 'googain-panther_panther-core-credit-matrix',
    // Willow
    'googain-willow_willow-cash-flow-advantage': 'googain-willow_willow-cash-flow-advantage',
    'googain-willow_willow-equity-advantage': 'googain-willow_willow-equity-advantage',
    'googain-willow_willow-equity-advantage-ces-eligibility': 'googain-willow_willow-equity-advantage-ces-eligibility',
    'googain-willow_willow-investor-advantage': 'googain-willow_willow-investor-advantage',
    'googain-willow_willow-investor-advantage-eligibility': 'googain-willow_willow-investor-advantage-eligibility',
    'googain-willow_willow-non-agency-advantage': 'googain-willow_willow-non-agency-advantage',
    'googain-willow_willow-non-agency-guidelines': 'googain-willow_willow-non-agency-guidelines',
    'googain-willow_willow-professional-investor': 'googain-willow_willow-professional-investor',
    'googain-willow_willow-summary-program-matrix': 'googain-willow_willow-summary-program-matrix',
    'googain-willow_willow-super-jumbo': 'googain-willow_willow-super-jumbo',
    'googain-willow_willow-titanium-advantage': 'googain-willow_willow-titanium-advantage',
    // Pebbles
    'googain-pebbles_pebbles-delegated-nonqm-matrix': 'googain-pebbles_pebbles-delegated-nonqm-matrix',
    // Bahamas
    'googain-bahamas_bahamas-loan-eligibility-guidelines': 'googain-bahamas_bahamas-loan-eligibility-guidelines',
    'googain-bahamas_bahamas-loan-eligibility-guidelines-equity-solutions': 'googain-bahamas_bahamas-loan-eligibility-guidelines-equity-solutions',
    'googain-bahamas_bahamas-matrix': 'googain-bahamas_bahamas-matrix',
    'googain-bahamas_bahamas-matrix-equity-solutions': 'googain-bahamas_bahamas-matrix-equity-solutions',
    // Glory
    'googain-glory_glory-2nd-lien-guidelines': 'googain-glory_glory-2nd-lien-guidelines',
    'googain-glory_glory-nqm': 'googain-glory_glory-nqm',
    'googain-glory_glory-qm-aus': 'googain-glory_glory-qm-aus',
}

export const PDF_TYPE_NAME = {
    [CONTENT_TYPES.FANNIE_MAE]: 'Fannie Mae',
    [CONTENT_TYPES.FHA]: 'FHA',
    [CONTENT_TYPES.VA]: 'VA',
    [CONTENT_TYPES.FREDDIE]: 'Freddie Mac',
    [CONTENT_TYPES.USDA]: 'USDA',
    [CONTENT_TYPES.NEW_WAVE_LENDING_DI_PRIME]: 'New Wave Lending DI Prime',
    [CONTENT_TYPES.NEW_WAVE_LENDING_DI]: 'New Wave Lending DI Investor',
    [CONTENT_TYPES.NEW_WAVE_LENDING_PL]: 'New Wave Lending Prodit and Loss',
    [CONTENT_TYPES.NEW_WAVE_LENDING_VOE]: 'New Wave Lending VOE',
    [CONTENT_TYPES.NEW_WAVE_LENDING_EP]: 'New Wave Lending Expanded Portfolio',
    [CONTENT_TYPES.NEWFI_NQMEP]: 'NewFi NQM Expanded Portfolio',
    [CONTENT_TYPES.NEWFI_NQMIEP]: 'NewFi NQM ITIN Expanded Portfolio',
    [CONTENT_TYPES.NEWFI_DSCR]: 'NewFi DSCR',
    [CONTENT_TYPES.NEWFI_FNDSCR]: 'NewFi FN DSCR',
    [CONTENT_TYPES.NEWFI_NQMP]: 'NewFi NQM',
    [CONTENT_TYPES.NEWFI_NQMIP]: 'NewFi NQM ITIN',
    [CONTENT_TYPES.NEWFI_PINN]: 'NewFi PINN',
    [CONTENT_TYPES.NEWFI_RAINER]: 'NewFi RAINER',
    [CONTENT_TYPES.AMWEST_ASSETQ]: 'AmWest Asset Qualifier',
    [CONTENT_TYPES.AMWEST_AITIN]: 'AmWest Advantage ITIN',
    [CONTENT_TYPES.AMWEST_AONE]: 'AmWest Advantage One',
    [CONTENT_TYPES.AMWEST_ADVANTAGE]: 'AmWest Advantage',
    [CONTENT_TYPES.AMWEST_INVESTOR]: 'AmWest Investor',
    [CONTENT_TYPES.AMWEST_INVESTOR_PLUS]: 'AmWest Investor Plus',
    [CONTENT_TYPES.AMWEST_BK]: 'AmWest BK Statement Advantage',
    [CONTENT_TYPES.CONSTRUCTIVE_CAPITAL_STANDARD_DSCR]: 'Constructive Capital Standard DSCR',
    [CONTENT_TYPES.CONSTRUCTIVE_CAPITAL_EXPANDED_DSCR]: 'Constructive Capital Expanded DSCR',
    [CONTENT_TYPES.AAA_PRIME_NO_DOC]: 'AAA Prime No Doc',
    [CONTENT_TYPES.AAA_NO_JOB_NO_INCOME]: 'AAA No Job No Income',
    [CONTENT_TYPES.AAA_SELF_PREPARED_PL]: 'AAA Self Prepared P&L WVOE',
    [CONTENT_TYPES.AAA_CPA_PREPARED_PL]: 'AAA CPA Prepared P&L WVOE',
    [CONTENT_TYPES.AAA_DSCR_PRIME]: 'AAA DSCR Prime',
    [CONTENT_TYPES.AAA_DSCR]: 'AAA DSCR',
    [CONTENT_TYPES.AAA_BANK_STATEMENT]: 'AAA Bank Statement',
    [CONTENT_TYPES.AAA_BRIDGE_LOAN]: 'AAA Bridge Loan 12-month Balloon',
    [CONTENT_TYPES.AAA_FIX_FLIP]: 'AAA Fix & Flip',
    [CONTENT_TYPES.AAA_PRIME_CES]: 'AAA Prime CES Closed End Second',
    [CONTENT_TYPES.AAA_DSCR_CES]: 'AAA DSCR CES Closed-End Second',
    [CONTENT_TYPES.AAA_EXPANDED_HELOC]: 'AAA Expanded HELOC',
    [CONTENT_TYPES.THUNDERBIRD]: 'Thunderbird',
    [CONTENT_TYPES.SCENARIO_GMCC]: 'Scenario GMCC',
    [CONTENT_TYPES.SCENARIO_DESK]: 'Scenario Desk',
    [CONTENT_TYPES.greenbox_ces_fd_bs_pl]: 'Greenbox CES FD BS PL',
    [CONTENT_TYPES.greenbox_combo_ces_bs_fd]: 'Greenbox Combo CES BS FD',
    [CONTENT_TYPES.greenbox_combo_bs_fd]: 'Greenbox Combo BS FD',
    [CONTENT_TYPES.greenbox_dscr_5_10_units_2_8_mix_use]: 'Greenbox DSCR 5-10 Units 2-8 Mix Use',
    [CONTENT_TYPES.greenbox_elite_dscr]: 'Greenbox Elite DSCR',
    [CONTENT_TYPES.greenbox_dscr_no_ratio]: 'Greenbox DSCR NO RATIO',
    [CONTENT_TYPES.greenbox_elite_plus_dscr]: 'Greenbox Elite Plus DSCR',
    [CONTENT_TYPES.greenbox_elite_plus_bs_pl_fd]: 'Greenbox Elite Plus BS PL FD',
    [CONTENT_TYPES.greenbox_elite_bs_pl_fd_1099]: 'Greenbox Elite BS PL FD 1099',
    [CONTENT_TYPES.greenbox_elite_wvoe]: 'Greenbox Elite WVOE AU',
    [CONTENT_TYPES.greenbox_fn_fd]: 'Greenbox FN Full Doc',
    [CONTENT_TYPES.greenbox_fn_dscr_itin]: 'Greenbox FN DSCR ITIN',
    [CONTENT_TYPES.greenbox_itin_bs]: 'Greenbox ITIN BS',
    [CONTENT_TYPES.greenbox_itin_fd]: 'Greenbox ITIN FD',
    [CONTENT_TYPES.greenbox_np_pl_fd]: 'Greenbox NP PL FD',
    [CONTENT_TYPES.greenbox_rh_bs_fd]: 'Greenbox RH BS FD',
    [CONTENT_TYPES.greenbox_super_jumbo]: 'Greenbox Super Jumbo',
    [CONTENT_TYPES.greenbox_ces_dscr]: 'Greenbox CES DSCR',
    [CONTENT_TYPES['googain-panther_panther-agency-eligible-noo-2nd-home-matrix']]: 'Panther Agency Eligible NOO 2nd home Matrix',
    [CONTENT_TYPES['googain-panther_panther-core-credit-guidelines']]: 'Panther CORE Credit Guidelines',
    [CONTENT_TYPES['googain-panther_panther-core-credit-matrix']]: 'Panther CORE Credit Matrix',
    // Willow
    [CONTENT_TYPES['googain-willow_willow-cash-flow-advantage']]: 'Willow Cash Flow Advantage',
    [CONTENT_TYPES['googain-willow_willow-equity-advantage']]: 'Willow Equity Advantage',
    [CONTENT_TYPES['googain-willow_willow-equity-advantage-ces-eligibility']]: 'Willow Equity Advantage CES Eligibility',
    [CONTENT_TYPES['googain-willow_willow-investor-advantage']]: 'Willow Investor Advantage',
    [CONTENT_TYPES['googain-willow_willow-investor-advantage-eligibility']]: 'Willow Investor Advantage Eligibility',
    [CONTENT_TYPES['googain-willow_willow-non-agency-advantage']]: 'Willow Non Agency Advantage',
    [CONTENT_TYPES['googain-willow_willow-non-agency-guidelines']]: 'Willow Non Agency Guidelines',
    [CONTENT_TYPES['googain-willow_willow-professional-investor']]: 'Willow Professional Investor',
    [CONTENT_TYPES['googain-willow_willow-summary-program-matrix']]: 'Willow Summary Program Matrix',
    [CONTENT_TYPES['googain-willow_willow-super-jumbo']]: 'Willow Super Jumbo',
    [CONTENT_TYPES['googain-willow_willow-titanium-advantage']]: 'Willow Titanium Advantage',
    // Pebbles
    [CONTENT_TYPES['googain-pebbles_pebbles-delegated-nonqm-matrix']]: 'Pebbles Delegated NonQM Matrix',
    // Bahamas
    [CONTENT_TYPES['googain-bahamas_bahamas-loan-eligibility-guidelines']]: 'Bahamas Loan Eligibility Guidelines',
    [CONTENT_TYPES['googain-bahamas_bahamas-loan-eligibility-guidelines-equity-solutions']]: 'Bahamas Loan Eligibility Guidelines Equity Solutions',
    [CONTENT_TYPES['googain-bahamas_bahamas-matrix']]: 'Bahamas Matrix',
    [CONTENT_TYPES['googain-bahamas_bahamas-matrix-equity-solutions']]: 'Bahamas Matrix Equity Solutions',
    // Glory
    [CONTENT_TYPES['googain-glory_glory-2nd-lien-guidelines']]: 'Glory 2nd Lien Guidelines',
    [CONTENT_TYPES['googain-glory_glory-nqm']]: 'Glory NQM',
    [CONTENT_TYPES['googain-glory_glory-qm-aus']]: 'Glory QM AUS',
}

export const PDF_CONTENT = {
    [CONTENT_TYPES.VA]: PDF_GUIDELINES.VA,
    [CONTENT_TYPES.FANNIE_MAE]: PDF_GUIDELINES.FANNIE_MAE,
    [CONTENT_TYPES.FHA]: PDF_GUIDELINES.FHA,
    [CONTENT_TYPES.FREDDIE]: PDF_GUIDELINES.FREDDIE,
    [CONTENT_TYPES.USDA]: PDF_GUIDELINES.USDA,
    [CONTENT_TYPES.NEW_WAVE_LENDING_DI_PRIME]: PDF_GUIDELINES.NEW_WAVE_LENDING_DI_PRIME,
    [CONTENT_TYPES.NEW_WAVE_LENDING_DI]: PDF_GUIDELINES.NEW_WAVE_LENDING_DI,
    [CONTENT_TYPES.NEW_WAVE_LENDING_PL]: PDF_GUIDELINES.NEW_WAVE_LENDING_PL,
    [CONTENT_TYPES.NEW_WAVE_LENDING_VOE]: PDF_GUIDELINES.NEW_WAVE_LENDING_VOE,
    [CONTENT_TYPES.NEW_WAVE_LENDING_EP]: PDF_GUIDELINES.NEW_WAVE_LENDING_EP,
    [CONTENT_TYPES.NEWFI_NQMEP]: PDF_GUIDELINES.NEWFI_NQMEP,
    [CONTENT_TYPES.NEWFI_NQMIEP]: PDF_GUIDELINES.NEWFI_NQMIEP,
    [CONTENT_TYPES.NEWFI_DSCR]: PDF_GUIDELINES.NEWFI_DSCR,
    [CONTENT_TYPES.NEWFI_FNDSCR]: PDF_GUIDELINES.NEWFI_FNDSCR,
    [CONTENT_TYPES.NEWFI_NQMP]: PDF_GUIDELINES.NEWFI_NQMP,
    [CONTENT_TYPES.NEWFI_NQMIP]: PDF_GUIDELINES.NEWFI_NQMIP,
    [CONTENT_TYPES.NEWFI_PINN]: PDF_GUIDELINES.NEWFI_PINN,
    [CONTENT_TYPES.NEWFI_RAINER]: PDF_GUIDELINES.NEWFI_RAINER,
    [CONTENT_TYPES.AMWEST_ASSETQ]: PDF_GUIDELINES.AMWEST_ASSETQ,
    [CONTENT_TYPES.AMWEST_AITIN]: PDF_GUIDELINES.AMWEST_AITIN,
    [CONTENT_TYPES.AMWEST_AONE]: PDF_GUIDELINES.AMWEST_AONE,
    [CONTENT_TYPES.AMWEST_ADVANTAGE]: PDF_GUIDELINES.AMWEST_ADVANTAGE,
    [CONTENT_TYPES.AMWEST_INVESTOR]: PDF_GUIDELINES.AMWEST_INVESTOR,
    [CONTENT_TYPES.AMWEST_INVESTOR_PLUS]: PDF_GUIDELINES.AMWEST_INVESTOR_PLUS,
    [CONTENT_TYPES.AMWEST_BK]: PDF_GUIDELINES.AMWEST_BK,
    [CONTENT_TYPES.CONSTRUCTIVE_CAPITAL_STANDARD_DSCR]: PDF_GUIDELINES.CONSTRUCTIVE_CAPITAL_STANDARD_DSCR,
    [CONTENT_TYPES.CONSTRUCTIVE_CAPITAL_EXPANDED_DSCR]: PDF_GUIDELINES.CONSTRUCTIVE_CAPITAL_EXPANDED_DSCR,
    [CONTENT_TYPES.AAA_PRIME_NO_DOC]: PDF_GUIDELINES.AAA_PRIME_NO_DOC,
    [CONTENT_TYPES.AAA_NO_JOB_NO_INCOME]: PDF_GUIDELINES.AAA_NO_JOB_NO_INCOME,
    [CONTENT_TYPES.AAA_SELF_PREPARED_PL]: PDF_GUIDELINES.AAA_SELF_PREPARED_PL,
    [CONTENT_TYPES.AAA_CPA_PREPARED_PL]: PDF_GUIDELINES.AAA_CPA_PREPARED_PL,
    [CONTENT_TYPES.AAA_DSCR_PRIME]: PDF_GUIDELINES.AAA_DSCR_PRIME,
    [CONTENT_TYPES.AAA_DSCR]: PDF_GUIDELINES.AAA_DSCR,
    [CONTENT_TYPES.AAA_BANK_STATEMENT]: PDF_GUIDELINES.AAA_BANK_STATEMENT,
    [CONTENT_TYPES.AAA_BRIDGE_LOAN]: PDF_GUIDELINES.AAA_BRIDGE_LOAN,
    [CONTENT_TYPES.AAA_FIX_FLIP]: PDF_GUIDELINES.AAA_FIX_FLIP,
    [CONTENT_TYPES.AAA_PRIME_CES]: PDF_GUIDELINES.AAA_PRIME_CES,
    [CONTENT_TYPES.AAA_DSCR_CES]: PDF_GUIDELINES.AAA_DSCR_CES,
    [CONTENT_TYPES.AAA_EXPANDED_HELOC]: PDF_GUIDELINES.AAA_EXPANDED_HELOC,
    [CONTENT_TYPES.THUNDERBIRD]: PDF_GUIDELINES.THUNDERBIRD,
    [CONTENT_TYPES.SCENARIO_GMCC]: PDF_GUIDELINES.SCENARIO_GMCC,
    [CONTENT_TYPES.SCENARIO_DESK]: null, // For scenario desk, we use dynamic PDFs only
    [CONTENT_TYPES.greenbox_ces_fd_bs_pl]: PDF_GUIDELINES.greenbox_ces_fd_bs_pl,
    [CONTENT_TYPES.greenbox_combo_ces_bs_fd]: PDF_GUIDELINES.greenbox_combo_ces_bs_fd,
    [CONTENT_TYPES.greenbox_combo_bs_fd]: PDF_GUIDELINES.greenbox_combo_bs_fd,
    [CONTENT_TYPES.greenbox_dscr_5_10_units_2_8_mix_use]: PDF_GUIDELINES.greenbox_dscr_5_10_units_2_8_mix_use,
    [CONTENT_TYPES.greenbox_elite_dscr]: PDF_GUIDELINES.greenbox_elite_dscr,
    [CONTENT_TYPES.greenbox_dscr_no_ratio]: PDF_GUIDELINES.greenbox_dscr_no_ratio,
    [CONTENT_TYPES.greenbox_elite_plus_dscr]: PDF_GUIDELINES.greenbox_elite_plus_dscr,
    [CONTENT_TYPES.greenbox_elite_plus_bs_pl_fd]: PDF_GUIDELINES.greenbox_elite_plus_bs_pl_fd,
    [CONTENT_TYPES.greenbox_elite_bs_pl_fd_1099]: PDF_GUIDELINES.greenbox_elite_bs_pl_fd_1099,
    [CONTENT_TYPES.greenbox_elite_wvoe]: PDF_GUIDELINES.greenbox_elite_wvoe,
    [CONTENT_TYPES.greenbox_fn_fd]: PDF_GUIDELINES.greenbox_fn_fd,
    [CONTENT_TYPES.greenbox_fn_dscr_itin]: PDF_GUIDELINES.greenbox_fn_dscr_itin,
    [CONTENT_TYPES.greenbox_itin_bs]: PDF_GUIDELINES.greenbox_itin_bs,
    [CONTENT_TYPES.greenbox_itin_fd]: PDF_GUIDELINES.greenbox_itin_fd,
    [CONTENT_TYPES.greenbox_np_pl_fd]: PDF_GUIDELINES.greenbox_np_pl_fd,
    [CONTENT_TYPES.greenbox_rh_bs_fd]: PDF_GUIDELINES.greenbox_rh_bs_fd,
    [CONTENT_TYPES.greenbox_super_jumbo]: PDF_GUIDELINES.greenbox_super_jumbo,
    [CONTENT_TYPES.greenbox_ces_dscr]: PDF_GUIDELINES.greenbox_ces_dscr,
    [CONTENT_TYPES['googain-panther_panther-agency-eligible-noo-2nd-home-matrix']]: PDF_GUIDELINES['googain-panther_panther-agency-eligible-noo-2nd-home-matrix'],
    [CONTENT_TYPES['googain-panther_panther-core-credit-guidelines']]: PDF_GUIDELINES['googain-panther_panther-core-credit-guidelines'],
    [CONTENT_TYPES['googain-panther_panther-core-credit-matrix']]: PDF_GUIDELINES['googain-panther_panther-core-credit-matrix'],
    // Willow
    [CONTENT_TYPES['googain-willow_willow-cash-flow-advantage']]: PDF_GUIDELINES['googain-willow_willow-cash-flow-advantage'],
    [CONTENT_TYPES['googain-willow_willow-equity-advantage']]: PDF_GUIDELINES['googain-willow_willow-equity-advantage'],
    [CONTENT_TYPES['googain-willow_willow-equity-advantage-ces-eligibility']]: PDF_GUIDELINES['googain-willow_willow-equity-advantage-ces-eligibility'],
    [CONTENT_TYPES['googain-willow_willow-investor-advantage']]: PDF_GUIDELINES['googain-willow_willow-investor-advantage'],
    [CONTENT_TYPES['googain-willow_willow-investor-advantage-eligibility']]: PDF_GUIDELINES['googain-willow_willow-investor-advantage-eligibility'],
    [CONTENT_TYPES['googain-willow_willow-non-agency-advantage']]: PDF_GUIDELINES['googain-willow_willow-non-agency-advantage'],
    [CONTENT_TYPES['googain-willow_willow-non-agency-guidelines']]: PDF_GUIDELINES['googain-willow_willow-non-agency-guidelines'],
    [CONTENT_TYPES['googain-willow_willow-professional-investor']]: PDF_GUIDELINES['googain-willow_willow-professional-investor'],
    [CONTENT_TYPES['googain-willow_willow-summary-program-matrix']]: PDF_GUIDELINES['googain-willow_willow-summary-program-matrix'],
    [CONTENT_TYPES['googain-willow_willow-super-jumbo']]: PDF_GUIDELINES['googain-willow_willow-super-jumbo'],
    [CONTENT_TYPES['googain-willow_willow-titanium-advantage']]: PDF_GUIDELINES['googain-willow_willow-titanium-advantage'],
    // Pebbles
    [CONTENT_TYPES['googain-pebbles_pebbles-delegated-nonqm-matrix']]: PDF_GUIDELINES['googain-pebbles_pebbles-delegated-nonqm-matrix'],
    // Bahamas
    [CONTENT_TYPES['googain-bahamas_bahamas-loan-eligibility-guidelines']]: PDF_GUIDELINES['googain-bahamas_bahamas-loan-eligibility-guidelines'],
    [CONTENT_TYPES['googain-bahamas_bahamas-loan-eligibility-guidelines-equity-solutions']]: PDF_GUIDELINES['googain-bahamas_bahamas-loan-eligibility-guidelines-equity-solutions'],
    [CONTENT_TYPES['googain-bahamas_bahamas-matrix']]: PDF_GUIDELINES['googain-bahamas_bahamas-matrix'],
    [CONTENT_TYPES['googain-bahamas_bahamas-matrix-equity-solutions']]: PDF_GUIDELINES['googain-bahamas_bahamas-matrix-equity-solutions'],
    // Glory
    [CONTENT_TYPES['googain-glory_glory-2nd-lien-guidelines']]: PDF_GUIDELINES['googain-glory_glory-2nd-lien-guidelines'],
    [CONTENT_TYPES['googain-glory_glory-nqm']]: PDF_GUIDELINES['googain-glory_glory-nqm'],
    [CONTENT_TYPES['googain-glory_glory-qm-aus']]: PDF_GUIDELINES['googain-glory_glory-qm-aus'],
}

export const PROMPT_EXAMPLES = {
    [CONTENT_TYPES.FANNIE_MAE]: DocPromptExamples,
    [CONTENT_TYPES.FHA]: FHADocPromptExamples,
    [CONTENT_TYPES.VA]: VADocPromptExamples,
    [CONTENT_TYPES.FREDDIE]: FreddieDocPromptExamples,
    [CONTENT_TYPES.USDA]: UsdaDocPromptExamples,
    [CONTENT_TYPES.NEW_WAVE_LENDING_DI_PRIME]: NewWaveLendingDIPrimeDocPromptExamples,
    [CONTENT_TYPES.NEW_WAVE_LENDING_DI]: NewWaveLendingDIDocPromptExamples,
    [CONTENT_TYPES.NEW_WAVE_LENDING_PL]: NewWaveLendingPLDocPromptExamples,
    [CONTENT_TYPES.NEW_WAVE_LENDING_VOE]: NewWaveLendingVOEDocPromptExamples,
    [CONTENT_TYPES.NEW_WAVE_LENDING_EP]: NewWaveLendingEPDocPromptExamples,
    [CONTENT_TYPES.NEWFI_NQMEP]: NewFiNQMEPDocPromptExamples,
    [CONTENT_TYPES.NEWFI_NQMIEP]: NewFiNQMIEPDocPromptExamples,
    [CONTENT_TYPES.NEWFI_DSCR]: NewFiDSCRDocPromptExamples,
    [CONTENT_TYPES.NEWFI_FNDSCR]: NewFiFNDSCRDocPromptExamples,
    [CONTENT_TYPES.NEWFI_NQMP]: NewFiNQMPDocPromptExamples,
    [CONTENT_TYPES.NEWFI_NQMIP]: NewFiNQMIPDocPromptExamples,
    [CONTENT_TYPES.NEWFI_PINN]: NewFiPINNDocPromptExamples,
    [CONTENT_TYPES.NEWFI_RAINER]: NewFiRAINERDocPromptExamples,

}

export const PDF_API_URL = {
    [CONTENT_TYPES.FANNIE_MAE]: '/los/mortgagegpt/askfanniemae',
    [CONTENT_TYPES.FHA]: '/los/mortgagegpt/askfha',
    [CONTENT_TYPES.VA]: '/los/mortgagegpt/askva',
    [CONTENT_TYPES.FREDDIE]: '/los/mortgagegpt/askfreddie',
    [CONTENT_TYPES.USDA]: '/los/mortgagegpt/askusda',
    [CONTENT_TYPES.NEW_WAVE_LENDING_DI_PRIME]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.NEW_WAVE_LENDING_DI]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.NEW_WAVE_LENDING_PL]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.NEW_WAVE_LENDING_VOE]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.NEW_WAVE_LENDING_EP]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.NEWFI_NQMEP]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.NEWFI_NQMIEP]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.NEWFI_DSCR]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.NEWFI_FNDSCR]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.NEWFI_NQMP]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.NEWFI_NQMIP]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.NEWFI_PINN]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.NEWFI_RAINER]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AMWEST_ASSETQ]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AMWEST_AITIN]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AMWEST_AONE]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AMWEST_ADVANTAGE]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AMWEST_INVESTOR]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AMWEST_INVESTOR_PLUS]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AMWEST_BK]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.CONSTRUCTIVE_CAPITAL_STANDARD_DSCR]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.CONSTRUCTIVE_CAPITAL_EXPANDED_DSCR]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AAA_PRIME_NO_DOC]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AAA_NO_JOB_NO_INCOME]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AAA_SELF_PREPARED_PL]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AAA_CPA_PREPARED_PL]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AAA_DSCR_PRIME]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AAA_DSCR]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AAA_BANK_STATEMENT]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AAA_BRIDGE_LOAN]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AAA_FIX_FLIP]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AAA_PRIME_CES]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AAA_DSCR_CES]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.AAA_EXPANDED_HELOC]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.THUNDERBIRD]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_ces_fd_bs_pl]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_combo_ces_bs_fd]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_combo_bs_fd]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_dscr_5_10_units_2_8_mix_use]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_elite_dscr]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_dscr_no_ratio]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_elite_plus_dscr]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_elite_plus_bs_pl_fd]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_elite_bs_pl_fd_1099]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_elite_wvoe]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_fn_fd]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_fn_dscr_itin]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_itin_bs]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_itin_fd]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_np_pl_fd]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_rh_bs_fd]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_super_jumbo]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.greenbox_ces_dscr]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-panther_panther-agency-eligible-noo-2nd-home-matrix']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-panther_panther-core-credit-guidelines']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-panther_panther-core-credit-matrix']]: '/los/mortgagegpt/asknonqm',
    // Willow
    [CONTENT_TYPES['googain-willow_willow-cash-flow-advantage']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-willow_willow-equity-advantage']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-willow_willow-equity-advantage-ces-eligibility']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-willow_willow-investor-advantage']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-willow_willow-investor-advantage-eligibility']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-willow_willow-non-agency-advantage']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-willow_willow-non-agency-guidelines']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-willow_willow-professional-investor']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-willow_willow-summary-program-matrix']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-willow_willow-super-jumbo']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-willow_willow-titanium-advantage']]: '/los/mortgagegpt/asknonqm',
    // Pebbles
    [CONTENT_TYPES['googain-pebbles_pebbles-delegated-nonqm-matrix']]: '/los/mortgagegpt/asknonqm',
    // Bahamas
    [CONTENT_TYPES['googain-bahamas_bahamas-loan-eligibility-guidelines']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-bahamas_bahamas-loan-eligibility-guidelines-equity-solutions']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-bahamas_bahamas-matrix']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-bahamas_bahamas-matrix-equity-solutions']]: '/los/mortgagegpt/asknonqm',
    // Glory
    [CONTENT_TYPES['googain-glory_glory-2nd-lien-guidelines']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-glory_glory-nqm']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES['googain-glory_glory-qm-aus']]: '/los/mortgagegpt/asknonqm',
    [CONTENT_TYPES.SCENARIO_GMCC]: '/los/mortgagegpt/askgmcc',
    [CONTENT_TYPES.SCENARIO_DESK]: '/los/mortgagegpt/scenariodesk',
}

export const GENERAL_GUIDELINES = [
    {
        id: CONTENT_TYPES.FANNIE_MAE,
        value: 'Fannie Mae Selling Guide',
    },
    {
        id: CONTENT_TYPES.FREDDIE,
        value: 'Freddie Mac Seller',
    },
    {
        id: CONTENT_TYPES.FHA,
        value: 'FHA Handbook',
    },
    {
        id: CONTENT_TYPES.VA,
        value: 'VA Lender\'s Handbook',
    },
    {
        id: CONTENT_TYPES.USDA,
        value: 'USDA Loan',
    },
]

export const findPromptAnswer = (question, type) => {
    const examples = PROMPT_EXAMPLES[type]
    if (!examples) return null;
    const prompt = examples.find(prompt => prompt.question === question)
    return prompt || null;
}

export const getPdfType = (type) => {
    switch (type) {
        case '':
        case 'FannieMae':
            return CONTENT_TYPES.FANNIE_MAE
        case 'VA':
            return CONTENT_TYPES.VA
        case 'FHA':
            return CONTENT_TYPES.FHA
        case 'FreddieMac':
            return CONTENT_TYPES.FREDDIE
        case 'USDA':
            return CONTENT_TYPES.USDA
        case 'GMCC_guidelines_demo':
            return CONTENT_TYPES.SCENARIO_GMCC
        case 'ScenarioDesk':
        case 'SCENARIO_DESK_guidelines':
            return CONTENT_TYPES.SCENARIO_DESK
        default:
            return ''
    }
}

// GMCC scenario desk filters
export const GMCC_SCENARIO_FILTERS = [
    { id: 'all', name: 'All' },
    { id: 'dscr', name: 'DSCR' },
    { id: 'bank_statement', name: 'Bank Statement' },
    { id: 'foreign_nationals', name: 'Foreign Nationals' },
    { id: 'asset_qualification', name: 'Asset Qualification' },
]

// GMCC scenario desk desk guidelines
export const GMCC_SCENARIO_GUIDELINES = [
    { id: 'gmcc_agate', name: 'Agate' },
    { id: 'gmcc_mercury', name: 'Mercury' },
    { id: 'gmcc_onyx', name: 'Onyx' },
    { id: 'gmcc_universe', name: 'Universe' },
]

// Scenario programs (individual programs instead of lenders)
export const SCENARIO_PROGRAMS = IS_ZEITRO ? [
    // MAXEX Programs
    { id: 'maxex_dscr', name: 'MAXEX DSCR Program', lender: 'MAXEX', tags: ['dscr'] },
    { id: 'maxex_jumbo', name: 'MAXEX Jumbo Express', lender: 'MAXEX', tags: ['jumbo'] },
    
    // Champions Funding Programs
    { id: 'champions_dscr_1_4', name: 'Champions DSCR 1-4 Units', lender: 'Champions Funding', tags: ['dscr'] },
    { id: 'champions_dscr_5_8', name: 'Champions DSCR 5-8 Units', lender: 'Champions Funding', tags: ['dscr'] },
    { id: 'champions_foreign_national', name: 'Champions Foreign National DSCR', lender: 'Champions Funding', tags: ['dscr', 'foreign_national'] },
    { id: 'champions_itin', name: 'Champions ITIN DSCR', lender: 'Champions Funding', tags: ['dscr', 'itin'] },

    // amerihome Programs
    { id: 'amerihome_dscr', name: 'AmeriHome Non-QM DSCR', lender: 'AmeriHome', tags: ['dscr'] },
    { id: 'amerihome_express_jumbo', name: 'AmeriHome Non-QM Express Jumbo', lender: 'AmeriHome', tags: ['jumbo'] },

    // bayview Programs
    { id: 'bayview_dscr', name: 'Bayview DSCR', lender: 'Bayview', tags: ['dscr'] },
    { id: 'bayview_jumbo', name: 'Bayview AUS Jumbo', lender: 'Bayview', tags: ['jumbo'] },

    // deephaven Programs
    { id: 'deephaven_dscr', name: 'Deephaven DSCR', lender: 'Deephaven', tags: ['dscr'] },
    { id: 'deephaven_non_qm', name: 'Deephaven Non-QM', lender: 'Deephaven', tags: ['dscr','bank_statement','form_1099','profit_and_loss'] },

    // Newrez
    { id: 'newrez_smartedge', name: 'Newrez Correspondent SmartEdge', lender: 'Newrez', tags: ['asset_utilization'] },
    // { id: 'newrez_smart_series', name: 'Newrez Smart Series', lender: 'Newrez', tags: ['dscr','bank_statement','form_1099','profit_and_loss'] },

    // NQM Funding
    { id: 'nqm_funding_combined_matrices', name: 'NQM Funding Flex Non-QM DSCR Combined Matrices', lender: 'NQM Funding', tags: ['dscr','bank_statement','form_1099','profit_and_loss', 'asset_utilization'] },
    { id: 'nqm_funding_underwriting_guidelines', name: 'NQM Funding Flex Non-QM DSCR Underwriting Guidelines', lender: 'NQM Funding', tags: ['dscr','bank_statement','form_1099','profit_and_loss', 'asset_utilization'] },


    // SG Capital Partners
    { id: 'sg_capital_partners_closed_end_second', name: 'SG Capital Partners Closed End Second', lender: 'SG Capital Partners', tags: ['dscr','bank_statement','form_1099','profit_and_loss','asset_utilization', 'wvoe'] },
    { id: 'sg_capital_partners_dscr_investor_connect_premier', name: 'SG Capital Partners DSCR Investor Connect Premier', lender: 'SG Capital Partners', tags: ['dscr'] },
    { id: 'sg_capital_partners_dscr_investor_connect_premier_underwriting_manual', name: 'SG Capital Partners DSCR Investor Connect Premier Underwriting Manual', lender: 'SG Capital Partners', tags: ['dscr'] },
    { id: 'sg_capital_partners_exception_restrictions', name: 'SG Capital Partners Exception Restrictions', lender: 'SG Capital Partners', tags: ['dscr','bank_statement','form_1099','profit_and_loss','asset_utilization', 'wvoe'] },
    { id: 'sg_capital_partners_prime_plus_flex_connect_matrices', name: 'SG Capital Partners Prime Plus Flex Connect Matrices', lender: 'SG Capital Partners', tags: ['dscr','bank_statement','form_1099','profit_and_loss','asset_utilization', 'wvoe'] },
    { id: 'sg_capital_partners_prime_plus_flex_connect_underwriting_manual', name: 'SG Capital Partners Prime Plus Flex Connect Underwriting Manual', lender: 'SG Capital Partners', tags: ['dscr','bank_statement','form_1099','profit_and_loss','asset_utilization', 'wvoe'] },


    // Versus Mortgage Capital
    // { id: 'versus_mortgage_capital_correspondent_non_agency_loan_ltv_matrix', name: 'Versus Mortgage Capital Correspondent Non-Agency Loan LTV Matrix', lender: 'Versus Mortgage Capital', tags: ['dscr','bank_statement','form_1099','profit_and_loss'] },
    { id: 'versus_non_agency_seller_guide', name: 'Versus Mortgage Capital Correspondent Non-Agency Seller Guide', lender: 'Versus Mortgage Capital', tags: ['itin','bank_statement','form_1099','profit_and_loss','asset_utilization'] },

] : IS_GREENBOX || PATH_CUSTOMER_ID === 'greenbox' ? [
    // Greenbox Programs
    { id: 'greenbox_ces_fd_bs_pl', name: 'CES FD, 1224BS & 1224 PL Only', lender: 'Greenbox', tags: ['bank_statement', 'profit_and_loss'] },
    { id: 'greenbox_combo_ces_bs_fd', name: 'Combo95 CES 24BSFD', lender: 'Greenbox', tags: ['bank_statement'] },
    { id: 'greenbox_combo_bs_fd', name: 'Combo95 24BS & FD', lender: 'Greenbox', tags: ['bank_statement'] },
    { id: 'greenbox_dscr_5_10_units_2_8_mix_use', name: 'DSCR 5-10 Units and 2-8 MixUse', lender: 'Greenbox', tags: ['dscr'] },
    { id: 'greenbox_elite_dscr', name: 'Eliet DSCR', lender: 'Greenbox', tags: ['dscr'] },
    { id: 'greenbox_dscr_no_ratio', name: 'DSCR - No Ratio', lender: 'Greenbox', tags: ['dscr'] },
    { id: 'greenbox_elite_plus_dscr', name: 'Elite Plus DSCR', lender: 'Greenbox', tags: ['dscr'] },
    { id: 'greenbox_elite_plus_bs_pl_fd', name: 'Elite Plus 1224BS, 24PL Only, 1224PL w 3BS & FD', lender: 'Greenbox', tags: ['bank_statement', 'profit_and_loss'] },
    { id: 'greenbox_elite_bs_pl_fd_1099', name: 'Elite 1224BS, PL Only, PL w 3BS, 1224 FD & 1099', lender: 'Greenbox', tags: ['bank_statement', 'profit_and_loss', 'form_1099'] },
    { id: 'greenbox_elite_wvoe', name: 'Elite WVOE AU', lender: 'Greenbox', tags: ['wvoe'] },
    { id: 'greenbox_fn_fd', name: 'Foreign National Full Doc', lender: 'Greenbox', tags: ['foreign_national'] },
    { id: 'greenbox_fn_dscr_itin', name: 'FN DSCR, ITIN DSCR', lender: 'Greenbox', tags: ['foreign_national', 'dscr', 'itin'] },
    { id: 'greenbox_itin_bs', name: 'ITIN, 12 or 24 BS', lender: 'Greenbox', tags: ['itin', 'bank_statement'] },
    { id: 'greenbox_itin_fd', name: 'ITIN Full Doc', lender: 'Greenbox', tags: ['itin'] },
    { id: 'greenbox_np_pl_fd', name: 'NP 1224BS, 1224PL w 3BS and 1224 FD', lender: 'Greenbox', tags: ['bank_statement','profit_and_loss'] },
    { id: 'greenbox_rh_bs_fd', name: 'RH 24BS and FD', lender: 'Greenbox', tags: ['bank_statement'] },
    { id: 'greenbox_super_jumbo', name: 'Super Jumbo 1224BS 1224FD', lender: 'Greenbox', tags: ['bank_statement','jumbo'] },
    { id: 'greenbox_ces_dscr', name: 'CES DSCR', lender: 'Greenbox', tags: ['dscr'] },


] : [
    // MAXEX Programs
    { id: 'maxex_dscr', name: 'MAXEX DSCR Program', lender: 'MAXEX', tags: ['dscr'] },
    { id: 'maxex_jumbo', name: 'MAXEX Jumbo Express', lender: 'MAXEX', tags: ['jumbo'] },
    
    // Champions Funding Programs
    { id: 'champions_dscr_1_4', name: 'Champions DSCR 1-4 Units', lender: 'Champions Funding', tags: ['dscr'] },
    { id: 'champions_dscr_5_8', name: 'Champions DSCR 5-8 Units', lender: 'Champions Funding', tags: ['dscr'] },
    { id: 'champions_foreign_national', name: 'Champions Foreign National DSCR', lender: 'Champions Funding', tags: ['dscr', 'foreign_national'] },
    { id: 'champions_itin', name: 'Champions ITIN DSCR', lender: 'Champions Funding', tags: ['dscr', 'itin'] },

    // amerihome Programs
    { id: 'amerihome_dscr', name: 'AmeriHome Non-QM DSCR', lender: 'AmeriHome', tags: ['dscr'] },
    { id: 'amerihome_express_jumbo', name: 'AmeriHome Non-QM Express Jumbo', lender: 'AmeriHome', tags: ['jumbo'] },

    // bayview Programs
    { id: 'bayview_dscr', name: 'Bayview DSCR', lender: 'Bayview', tags: ['dscr'] },
    { id: 'bayview_jumbo', name: 'Bayview AUS Jumbo', lender: 'Bayview', tags: ['jumbo'] },

    // NQM Funding
    { id: 'nqm_funding_combined_matrices', name: 'NQM Funding Flex Non-QM DSCR Combined Matrices', lender: 'NQM Funding', tags: ['dscr','bank_statement','form_1099','profit_and_loss', 'asset_utilization'] },
    { id: 'nqm_funding_underwriting_guidelines', name: 'NQM Funding Flex Non-QM DSCR Underwriting Guidelines', lender: 'NQM Funding', tags: ['dscr','bank_statement','form_1099','profit_and_loss', 'asset_utilization'] },

]

// Scenario program filters
export const SCENARIO_PROGRAM_FILTERS = IS_ZEITRO ? [
    { id: 'all', name: 'All' },
    { id: 'dscr', name: 'DSCR' },
    { id: 'jumbo', name: 'Jumbo' },
    { id: 'foreign_national', name: 'Foreign National' },
    { id: 'itin', name: 'ITIN' },
    { id: 'asset_utilization', name: 'Asset Utilization' },
    { id: 'wvoe', name: 'WVOE' },
    { id: 'bank_statement', name: 'Bank Statement' },
    { id: 'form_1099', name: 'Form 1099' },
    { id: 'profit_and_loss', name: 'Profit and Loss' },
] : [
    { id: 'all', name: 'All' },
    { id: 'dscr', name: 'DSCR' },
    { id: 'jumbo', name: 'Jumbo' },
    { id: 'foreign_national', name: 'Foreign National' },
    { id: 'itin', name: 'ITIN' },
    { id: 'bank_statement', name: 'Bank Statement' },
    { id: 'profit_and_loss', name: 'Profit and Loss' },
]

// API data transformation functions
let _LENDER_INFO_CACHE = null;
let _PROGRAM_PDF_MAPPING_CACHE = null;

/**
 * Transform API data from /api/v1/mortgagegpt/listAllPrograms to LENDER_INFO structure
 * @param {Array} apiData - Array of objects from the API
 * @returns {Object} - LENDER_INFO structure
 */
function transformApiDataToLenderInfo(apiData) {
    // Validate input data
    if (!apiData || !Array.isArray(apiData)) {
        console.error('Invalid API data for lender info:', apiData);
        return {};
    }
    
    const lenderGroups = {};
    apiData.forEach(item => {
        if (!item || !item.lenderName || !item.fileName) {
            console.warn('Invalid item in API data:', item);
            return;
        }
        
        const lenderKey = item.lenderDisplayName;
        if (!lenderGroups[lenderKey]) {
            const displayName = item.lenderDisplayName;
            lenderGroups[lenderKey] = {
                name: displayName,
                displayName: displayName,
                pdfs: []
            };
        }
        
        // Try S3 path first (only if it's a valid PDF path), otherwise fallback to local path
        const s3Url = convertS3PathToUrl(item.filePath, item.fileName);
        const pdfPath = s3Url || `/scenario_pdfs/${item.fileName}`;
        
        lenderGroups[lenderKey].pdfs.push({
            path: pdfPath,
            displayName: item.fileName,
            keywords: item.keyWords
        });
    });
    
    return lenderGroups;
}

/**
 * Transform API data to PROGRAM_PDF_MAPPING structure
 * @param {Array} apiData - Array of objects from the API
 * @returns {Object} - PROGRAM_PDF_MAPPING structure
 */
function transformApiDataToProgramMapping(apiData) {
    // Validate input data
    if (!apiData || !Array.isArray(apiData)) {
        console.error('Invalid API data for program mapping:', apiData);
        return {};
    }
    
    const mapping = {};
    
    apiData.forEach(item => {
        if (item && item.programName && item.fileName) {
            // Try S3 path first (only if it's a valid PDF path), otherwise fallback to local path
            const s3Url = convertS3PathToUrl(item.filePath, item.fileName);
            mapping[item.programName] = s3Url || `/scenario_pdfs/${item.fileName}`;
        }
    });
    
    return mapping;
}

/**
 * Fetch lender info from API
 * @returns {Promise<Object>} - LENDER_INFO structure
 */
async function fetchLenderInfo() {
    try {
        const token = sessionStorage.getItem("ZeitroA");
        const response = await fetch('/api/v1/mortgagegpt/listAllPrograms', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const apiResponse = await response.json();
        const apiData = apiResponse.data.all_documents || [];
        const transformedData = transformApiDataToLenderInfo(apiData);
        return transformedData;
    } catch (error) {
        return {};
    }
}

/**
 * Fetch program PDF mapping from API
 * @returns {Promise<Object>} - PROGRAM_PDF_MAPPING structure
 */
async function fetchProgramMapping() {
    try {
        const token = sessionStorage.getItem("ZeitroA");
        const response = await fetch('/api/v1/mortgagegpt/listAllPrograms', {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const apiResponse = await response.json();
        const apiData = apiResponse.data.all_documents || [];
        const transformedData = transformApiDataToProgramMapping(apiData);
        return transformedData;
    } catch (error) {
        return {};
    }
}

/**
 * Get LENDER_INFO with caching
 * @returns {Promise<Object>} - LENDER_INFO structure
 */
export async function getLenderInfo() {
    if (!_LENDER_INFO_CACHE) {
        _LENDER_INFO_CACHE = await fetchLenderInfo();
    }
    return _LENDER_INFO_CACHE;
}

/**
 * Get PROGRAM_PDF_MAPPING with caching
 * @returns {Promise<Object>} - PROGRAM_PDF_MAPPING structure
 */
export async function getProgramMapping() {
    if (!_PROGRAM_PDF_MAPPING_CACHE) {
        _PROGRAM_PDF_MAPPING_CACHE = await fetchProgramMapping();
    }
    return _PROGRAM_PDF_MAPPING_CACHE;
}

/**
 * Refresh cached data
 */
export function refreshLenderInfo() {
    _LENDER_INFO_CACHE = null;
    _PROGRAM_PDF_MAPPING_CACHE = null;
}

// Helper functions for lender and PDF operations (async versions)
export const findPdfByKeywords = async (fileName) => {
    // Normalize fileName first - remove extra spaces and fix common issues
    let normalizedFileName = fileName.trim().replace(/\s+\.pdf$/i, '.pdf').replace(/\s+/g, ' ')
    
    // Agency Guidelines mapping - these have their own PDF files
    const agencyGuidelinesMappings = [
        { pattern: /^FHA\s*(Guidelines?|Handbook)?$/i, path: '/scenario_pdfs/FHA-Guidelines.pdf' },
        { pattern: /^VA\s*(Guidelines?|Handbook|Lender'?s?\s*Handbook)?$/i, path: '/scenario_pdfs/VA-Guidelines.pdf' },
        { pattern: /^USDA\s*(Guidelines?|Loan)?$/i, path: '/scenario_pdfs/USDA-Guidelines.pdf' },
        { pattern: /^Fannie\s*Mae\s*(Selling\s*Guide|Guidelines?)?$/i, path: '/scenario_pdfs/Fannie-Mae-Guidelines.pdf' },
        { pattern: /^Freddie\s*Mac\s*(Seller|Guidelines?)?$/i, path: '/scenario_pdfs/Freddie-Mac-Guidelines.pdf' },
    ]
    
    // Remove .pdf suffix and page number suffix for checking 
    // (e.g., "FHA Guidelines.pdf" -> "FHA Guidelines", "FHA Guidelines, p.472" -> "FHA Guidelines")
    const fileNameForCheck = normalizedFileName
        .replace(/\.pdf$/i, '')
        .replace(/,?\s*p\.?\s*\d+(-\d+)?$/i, '')
        .trim()
    
    // Check if it's an Agency Guideline and return the corresponding PDF path
    for (const { pattern, path } of agencyGuidelinesMappings) {
        if (pattern.test(fileNameForCheck)) {
            return path
        }
    }
    
    const lenderInfo = await getLenderInfo();
    let bestMatch = null
    let maxScore = 0
    let maxLongestKeyword = 0
    
    // Use normalized fileName for matching
    const fileNameToMatch = normalizedFileName
    
    // Normalize input for comparison
    const normalizedInput = fileNameToMatch.toLowerCase().replace(/[^a-z0-9]/g, '')
    
    // Extract document name without lender prefix for better matching
    // Support formats: "Lender_DocumentName.pdf" or "Lender - DocumentName.pdf"
    let documentNameOnly = fileNameToMatch
    const underscoreIndex = documentNameOnly.indexOf('_')
    if (underscoreIndex !== -1) {
        documentNameOnly = documentNameOnly.substring(underscoreIndex + 1).trim()
    } else if (documentNameOnly.includes(' - ')) {
        const dashIndex = documentNameOnly.indexOf(' - ')
        documentNameOnly = documentNameOnly.substring(dashIndex + 3).trim()
    }
    const normalizedDocumentNameOnly = documentNameOnly.toLowerCase().replace(/[^a-z0-9]/g, '')
    
    // Use document name only for matching if it's different from the full filename
    // This ensures we match the actual document name, not the lender prefix
    const fileNameForMatching = (normalizedDocumentNameOnly && normalizedDocumentNameOnly !== normalizedInput) 
        ? documentNameOnly 
        : fileNameToMatch
    
    for (const [lenderId, lender] of Object.entries(lenderInfo)) {
        for (const pdf of lender.pdfs) {
            const pdfDisplayName = pdf.displayName || ''
            const normalizedPdfName = pdfDisplayName.toLowerCase().replace(/[^a-z0-9]/g, '')
            
            // Priority 1: Exact match with document name only (without lender prefix) - highest priority
            // This handles cases like "AcraLending_WS-Ratematrix-DSCR-Summary.pdf" -> "WS-Ratematrix-DSCR-Summary.pdf"
            // Use strict equality to avoid substring false positives
            if (normalizedDocumentNameOnly && normalizedDocumentNameOnly !== normalizedInput) {
                if (normalizedDocumentNameOnly === normalizedPdfName) {
                    // Exact match with document name only - return immediately
                    return pdf.path
                }
            }
            
            // Priority 2: Exact match with full filename (only if document name match failed)
            // Use strict equality to avoid substring false positives
            if (normalizedInput === normalizedPdfName) {
                // Exact match - return immediately
                return pdf.path
            }
            
            // Priority 2: Calculate weighted score based on keyword matches
            // Longer keywords get higher weight (more specific = better match)
            // Check both fileNameToMatch (for lender keywords) and fileNameForMatching (for document keywords)
            let score = 0
            let matchCount = 0
            let longestMatchedKeyword = 0
            for (const keyword of pdf.keywords || []) {
                // Check if keyword matches in either the fileNameToMatch or the document name only
                // This handles cases where lender name is in the keyword but not in the document name
                if (fileNameToMatch.includes(keyword) || fileNameForMatching.includes(keyword)) {
                    matchCount++
                    // Weight by keyword length - longer keywords are more specific
                    score += keyword.length
                    // Track the longest matched keyword for tie-breaking
                    if (keyword.length > longestMatchedKeyword) {
                        longestMatchedKeyword = keyword.length
                    }
                }
            }
            
            // Require at least 2 keyword matches
            // When scores are equal, prefer the match with the longest keyword (more specific)
            if (matchCount >= 2 && (score > maxScore || (score === maxScore && longestMatchedKeyword > maxLongestKeyword))) {
                maxScore = score
                maxLongestKeyword = longestMatchedKeyword
                bestMatch = pdf.path
            }
        }
    }
    
    return bestMatch
}






export const getFirstPdfForLender = async (lenderName) => {
    const lenderInfo = await getLenderInfo();
    for (const [lenderId, lender] of Object.entries(lenderInfo)) {
        if (lender.name === lenderName || lender.displayName === lenderName) {
            return lender.pdfs[0]?.displayName || null
        }
    }
    return null
}


export const getFirstPdfForProgram = async (programName) => {
    const [lenderInfo, programMapping] = await Promise.all([
        getLenderInfo(),
        getProgramMapping()
    ]);
    
    const program = SCENARIO_PROGRAMS.find(p => p.name === programName)
    if (program) {
        const pdfPath = programMapping[program.id]
        if (pdfPath) {
            // Find the corresponding PDF info from LENDER_INFO
            for (const [lenderId, lender] of Object.entries(lenderInfo)) {
                const pdf = lender.pdfs.find(p => p.path === pdfPath)
                if (pdf) {
                    return pdf.displayName
                }
            }
        }
    }
    return null
}
/**
 * Convert S3 path to accessible HTTPS URL
 * @param {string} s3Path - S3 path like "s3://bucket/key" or just the key
 * @param {string} fileName - PDF file name as fallback
 * @returns {string|null} - Accessible HTTPS URL, or null if path is invalid
 */
export const convertS3PathToUrl = (s3Path, fileName) => {
    // S3 bucket and region configuration
    const S3_BUCKET = 'scenarioai-guidelines';
    const S3_REGION = 'us-west-1';
    
    if (!s3Path) {
        return null;
    }
    
    // Only process PDF files, skip .txt or other formats (legacy data)
    if (!s3Path.toLowerCase().endsWith('.pdf')) {
        return null;
    }
    
    let s3Key = s3Path;
    
    // Handle s3:// protocol format
    if (s3Path.startsWith('s3://')) {
        // Extract key from s3://bucket/key format
        const pathWithoutProtocol = s3Path.replace('s3://', '');
        const firstSlashIndex = pathWithoutProtocol.indexOf('/');
        if (firstSlashIndex !== -1) {
            s3Key = pathWithoutProtocol.substring(firstSlashIndex + 1);
        }
    }
    
    // URL encode the key (but preserve slashes)
    const encodedKey = s3Key.split('/').map(part => encodeURIComponent(part)).join('/');
    
    // Build the S3 HTTPS URL
    return `https://${S3_BUCKET}.s3.${S3_REGION}.amazonaws.com/${encodedKey}`;
};

export const getPdfOptionsForPrograms = (selectedProgramIds, dbPrograms) => {
    const { MAP_GUIDELINE_ID, GUIDELINES } = dbPrograms;
    if (!selectedProgramIds || selectedProgramIds.length === 0) {
        return []
    }
    
    const pdfOptions = []
    selectedProgramIds.forEach(programId => {
        let program = null
        let pdfPath = null
        
        if (GUIDELINES && GUIDELINES.length > 0) {
            // For database programs, match by program_id (UUID)
            program = MAP_GUIDELINE_ID[programId];
            
            if (program && !program.isHidden) {
                // Try S3 path first (only if it's a valid PDF path)
                const s3Url = convertS3PathToUrl(program.filePath, program.fileName);
                if (s3Url) {
                    pdfPath = s3Url;
                } else {
                    // Fallback to local path if S3 path is not available or invalid
                    pdfPath = `/scenario_pdfs/${program.fileName}`;
                }
                
                if (pdfPath) {
                    pdfOptions.push({
                        value: pdfPath,
                        label: program.displayName,
                        pdfPath: pdfPath,
                        programId: program.id,
                        programName: program.programName,
                        lenderName: program.lenderName || 'Unknown'
                    })
                }
            }
        }
    })
    return pdfOptions
}

// GMCC scenario desk filter to guideline mappings
export const FILTER_GUIDELINES_MAPPING = {
    dscr: ['gmcc_agate', 'gmcc_mercury', 'gmcc_onyx', 'gmcc_universe'],
    bank_statement: ['gmcc_agate', 'gmcc_mercury', 'gmcc_onyx'],
    foreign_nationals: ['gmcc_mercury', 'gmcc_universe'],
    asset_qualification: [
        'gmcc_agate',
        'gmcc_mercury',
        'gmcc_onyx',
        'gmcc_universe',
    ],
}

// Scenario program filter to program mappings
export const FILTER_PROGRAMS_MAPPING = {
    dscr: ['maxex_dscr', 'champions_dscr_1_4', 'champions_dscr_5_8', 'champions_foreign_national', 'champions_itin', 'amerihome_dscr', 'bayview_dscr', 'deephaven_dscr', 'newrez_smartedge', 'nqm_funding_combined_matrices', 'nqm_funding_underwriting_guidelines', 'sg_capital_partners_closed_end_second', 'sg_capital_partners_dscr_investor_connect_premier', 'sg_capital_partners_dscr_investor_connect_premier_underwriting_manual', 'sg_capital_partners_exception_restrictions', 'sg_capital_partners_prime_plus_flex_connect_matrices', 'sg_capital_partners_prime_plus_flex_connect_underwriting_manual', 'versus_non_agency_seller_guide', 'greenbox_dscr_5_10_units_2_8_mix_use'],
    jumbo: ['maxex_jumbo', 'amerihome_express_jumbo', 'bayview_jumbo'],
    foreign_national: ['champions_foreign_national'],
    itin: ['champions_itin', 'versus_non_agency_seller_guide'],
    asset_utilization: ['newrez_smartedge', 'nqm_funding_combined_matrices', 'sg_capital_partners_closed_end_second', 'sg_capital_partners_prime_plus_flex_connect_matrices', 'versus_non_agency_seller_guide'],
    wvoe: ['sg_capital_partners_closed_end_second', 'sg_capital_partners_prime_plus_flex_connect_matrices'],
    bank_statement: ['greenbox_ces_fd_bs_pl', 'greenbox_combo_ces_bs_fd','greenbox_combo_bs_fd'],
    profit_and_loss: ['greenbox_ces_fd_bs_pl']
}

/**
 * @name getIframesKey 获取 “IFRAMES” 模式下的用户token
 * @description Iframe 模式不同的lender需要做token 登陆状态隔离，这里根据lender返回不同的token key
 */
export function getIframesToken() {
    return `zeitro_iframe_${PATH_CUSTOMER_ID}`;
}

export function getCheckoutStatus() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('checkout_status');
}
